import { Injectable } from '@angular/core';

declare const returnHomeAndroid;

declare global {
    interface Window {
        webkit: any;
    }
}

@Injectable({ providedIn: 'root' })
export class ReturnHomeService {


    returnCommunicator(): void {
        /**
         * Send mensage for IOS or Android
         */
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.returnHomeIOS) {
            this.comunicationIos();
        } else {
            this.comunicationAndroid();
        }
    }

    private comunicationIos() {
        window.webkit.messageHandlers.returnHomeIOS.postMessage({
            param: 'returnHome'
        });
    }

    private comunicationAndroid() {
        const param = 'returnHome';
        try {
            returnHomeAndroid.postMessage(param);
        } catch (error) {
        }
    }
}

